/* eslint-disable @typescript-eslint/restrict-template-expressions */
import authorizationService from 'common/services/security/authorizationService';
import {
  PAGES,
  TABS,
  ENGAGEMENT_HUB,
  ENGAGEMENT_TEAM_OWNER,
  ET_TEAM_MEMBERS_PATH,
} from './UserMangementConstants';

const constructLoginUrl = () => {
  const { origin } = window.location;
  const redirectUri = `${origin}/access`;
  const encodedRedirectUri = btoa(redirectUri);

  const loginUrl = `${process.env.REACT_APP_LOGIN_URL}/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/authorize?
  response_type=code&response_mode=query&client_id=${process.env.REACT_APP_CLIENT_ID}&
  redirect_uri=${redirectUri}&scope=${process.env.REACT_APP_CDE_API_SCOPE}
  openid offline_access&state=${encodedRedirectUri}`;
  return loginUrl;
};

const navigateToEngagementOwner = (projectId: string) => {
  const { origin } = window.location;
  return `${origin}/projects/${projectId}/${ET_TEAM_MEMBERS_PATH}`;
};

const constructEngagementUrl = (
  engagementId: string,
  page: string,
  tab: string
) => {
  let path = `${process.env.REACT_APP_DS_CREATE_URL}projects/${engagementId}/team-members`;
  switch (page) {
    case PAGES.ENGAGEMENT_TEAM_PAGE:
      path += '/engagement-team';
      break;
    case PAGES.CLIENT_TEAM_PAGE:
      path += '/client-team';
      break;
    case PAGES.THIRD_PARTY_TEAM_PAGE:
      path += '/third-parties';
      break;
    default:
      path += '/engagement-team';
      break;
  }

  switch (tab) {
    case TABS.MEMBERS:
      path += '/members';
      break;
    case TABS.REQUESTS:
      path += '/requests';
      break;
    default:
      path += '/members';
      break;
  }
  return path;
};

const pwcOwnerETMemberTab = (engagementId: string) => (
  <p>
    To add, remove or change permission levels, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      href={constructEngagementUrl(
        engagementId,
        PAGES.ENGAGEMENT_TEAM_PAGE,
        TABS.MEMBERS
      )}
      target="_blank"
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcOwnerETRequestTab = (engagementId: string) => (
  <p>
    To approve pending requests, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      target="_blank"
      href={constructEngagementUrl(
        engagementId,
        PAGES.ENGAGEMENT_TEAM_PAGE,
        TABS.REQUESTS
      )}
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcOwnerCTMemberTab = (engagementId: string) => (
  <p>
    To add or remove client team members, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      target="_blank"
      href={constructEngagementUrl(
        engagementId,
        PAGES.CLIENT_TEAM_PAGE,
        TABS.MEMBERS
      )}
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcOwnerCTRequestTab = (engagementId: string) => (
  <p>
    To approve pending requests, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      target="_blank"
      href={constructEngagementUrl(
        engagementId,
        PAGES.CLIENT_TEAM_PAGE,
        TABS.REQUESTS
      )}
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcOwnerTTMemberTab = (engagementId: string) => (
  <p>
    To add or remove third party members, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      target="_blank"
      href={constructEngagementUrl(
        engagementId,
        PAGES.THIRD_PARTY_TEAM_PAGE,
        TABS.MEMBERS
      )}
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcOwnerTTRequestTab = (engagementId: string) => (
  <p>
    To approve pending requests, go to{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      rel="noreferrer"
      target="_blank"
      href={constructEngagementUrl(
        engagementId,
        PAGES.THIRD_PARTY_TEAM_PAGE,
        TABS.REQUESTS
      )}
    >
      {ENGAGEMENT_HUB}
      <span className="Appkit4-icon icon-open-in-new-window-outline ap-font-16" />
    </a>
  </p>
);

const pwcEditOrViewerETMembersTab = (
  <>
    To request new member access to the project, select ‘Request new members’
    next to each role.
  </>
);

const pwcEditOrViewerETRequestTab = (projectId: string) => (
  <p>
    Pending requests can only be approved by{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      href={navigateToEngagementOwner(projectId)}
    >
      {ENGAGEMENT_TEAM_OWNER}
    </a>
  </p>
);

// Same message for client, third party members tab
const editorOrViewerOrClientMembersTab = (
  <>
    Request access to the project for new members and organisations. Make sure
    you request new members to the appropriate organisation.
  </>
);

// Same message for client, third party requests tab, same message for clients across all request tabs
const editorOrViewerOrClientRequestTab = (projectId: string) => (
  <p>
    Pending requests can only be approved by{' '}
    <a
      style={{
        textDecoration: 'underline',
      }}
      href={navigateToEngagementOwner(projectId)}
    >
      {ENGAGEMENT_TEAM_OWNER}
    </a>
  </p>
);

const clientETMembersTab =
  'Only engagement team members can add or request new members.';

const engagementTeamMessages = (engagementId: string, projectId: string) => {
  return {
    membersTab: {
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerETMemberTab(engagementId) },
        ],
      },
      editor: {
        messages: [{ type: 'info', message: pwcEditOrViewerETMembersTab }],
      },
      viewer: {
        messages: [{ type: 'info', message: pwcEditOrViewerETMembersTab }],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: clientETMembersTab,
          },
        ],
      },
    },
    requestsTab: {
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerETRequestTab(engagementId) },
        ],
      },
      editor: {
        messages: [
          { type: 'info', message: pwcEditOrViewerETRequestTab(projectId) },
        ],
      },
      viewer: {
        messages: [
          { type: 'info', message: pwcEditOrViewerETRequestTab(projectId) },
        ],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
    },
  };
};

const clientTeamMessages = (engagementId: string, projectId: string) => {
  return {
    membersTab: {
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerCTMemberTab(engagementId) },
        ],
      },
      editor: {
        messages: [{ type: 'info', message: editorOrViewerOrClientMembersTab }],
      },
      viewer: {
        messages: [{ type: 'info', message: editorOrViewerOrClientMembersTab }],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientMembersTab,
          },
        ],
      },
    },
    requestsTab: {
      enableModalBeforeInitialRequestMember: true,
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerCTRequestTab(engagementId) },
        ],
      },
      editor: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
      viewer: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
    },
  };
};

const thirdPartyTeamMessages = (engagementId: string, projectId: string) => {
  return {
    membersTab: {
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerTTMemberTab(engagementId) },
        ],
      },
      editor: {
        messages: [{ type: 'info', message: editorOrViewerOrClientMembersTab }],
      },
      viewer: {
        messages: [{ type: 'info', message: editorOrViewerOrClientMembersTab }],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientMembersTab,
          },
        ],
      },
    },
    requestsTab: {
      owner: {
        messages: [
          { type: 'info', message: pwcOwnerTTRequestTab(engagementId) },
        ],
      },
      editor: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
      viewer: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
      client: {
        messages: [
          {
            type: 'info',
            message: editorOrViewerOrClientRequestTab(projectId),
          },
        ],
      },
    },
  };
};

export const prepareUMMFEProps = (
  projectId: string,
  isUserThemeDarkMode: boolean,
  engagementId: string,
  language?: string
) => {
  const accessToken = authorizationService.getToken().access_token;
  return {
    dependencies: {},
    app: {
      basePath: `/projects/${projectId}/team-members`,
      theme: {
        colorMode: isUserThemeDarkMode ? 'dark' : 'light',
        colorTheme: 'orange',
      },
    },
    api: {
      basePath: process.env.REACT_APP_CDE_API,
      gifApiKey: process.env.REACT_APP_CDE_GIF_API_KEY,
    },
    auth: {
      api: {
        scopes: [],
      },
      accessToken,
      loginUri: constructLoginUrl(),
    },
    options: {
      projectId: engagementId,
      viewSettings: [
        'Owner_NonAdmin_View',
        'NonOwner_Default_View',
        'Client_Default_View',
      ],
      modules: {
        engagementTeam: engagementTeamMessages(engagementId, projectId),
        clientTeam: clientTeamMessages(engagementId, projectId),
        thirdParties: thirdPartyTeamMessages(engagementId, projectId),
      },
      language,
    },
    layout: {
      colorMode: isUserThemeDarkMode ? 'dark' : 'light',
      colorTheme: 'orange',
    },
  };
};

export const umMfeFn = {
  cleanUpFunc: undefined,
};
